import { useEffect } from 'react';

import { useAtom, useAtomValue } from 'jotai';

import appConfig from 'app-config';

import { RESTClient } from 'src/apis/service';
import { MatchService } from 'src/apis/service/MatchService';
import { remoteConfigAtom } from 'src/stores/auth/atoms';
import { recentMatchCountAtom } from 'src/stores/match/atoms';

/** @see {https://www.notion.so/hpcnt/REST-API-1b3ce00cd35480899f64f08d18496559?pvs=4#1b4ce00cd35480ef802cd49cae40407d} */
let refCount = 0;
let pollingIntervalId: number;
const DEFAULT_REFETCH_MATCH_COUNT_INTERVAL = 1000 * 60 * 10;
let mangleIntervalId: number;
const MANGLE_MATCH_COUNT_INTERVAL = 1000 * 3;

const service = new MatchService(new RESTClient());
const fetchMatchCount = async () => {
  try {
    return appConfig.serviceCode === 'vividi'
      ? await service.getRealtimeMatchCountForVividi()
      : await service.getRealtimeMatchCount();
  } catch {
    // 실패 시 무시
  }
};

function randrange(start = 0, stop?: number): number {
  if (stop === undefined) {
    stop = start;
    start = 0;
  }

  const width = stop - start;

  if (width <= 0) {
    return start;
  }

  return Math.floor(Math.random() * width) + start;
}

const useRestMatchCount = () => {
  const { recentlyMatchCountIntervalMS = DEFAULT_REFETCH_MATCH_COUNT_INTERVAL } =
    useAtomValue(remoteConfigAtom) ?? {};

  const [matchCount, setMatchCount] = useAtom(recentMatchCountAtom);

  useEffect(() => {
    if (++refCount === 1) {
      const update = async () => {
        const res = await fetchMatchCount();
        if (res?.count) {
          setMatchCount(res.count);
        }
      };
      const mangleMatchCount = () => {
        setMatchCount((prev) => Math.abs(randrange(prev - 100, prev + 100)));
      };

      update();
      pollingIntervalId = window.setInterval(update, recentlyMatchCountIntervalMS);
      mangleIntervalId = window.setInterval(mangleMatchCount, MANGLE_MATCH_COUNT_INTERVAL);
    }
    return () => {
      if (--refCount === 0) {
        clearInterval(pollingIntervalId);
        clearInterval(mangleIntervalId);
      }
    };
  }, [recentlyMatchCountIntervalMS, setMatchCount]);

  return matchCount;
};

export default useRestMatchCount;
